import { Grid } from '@mui/material';
import { SkeletonList } from '../skeleton-list/SkeletonList';

export const SocialAuthSkeleton: React.FC = () => {
  return (
    <Grid container>
      <SkeletonList
        sx={{ mr: 2, mt: 2, borderRadius: '10rem' }}
        variant="rectangular"
        itemsCount={3}
        height="2.5rem"
        width="7.5rem"
      ></SkeletonList>
    </Grid>
  );
};
